<template>
    <div class="common_data_wrap">
        <div class="banner flex-justify-content">
            <div>
                <div class="banner_title">通用数据库</div>
                <div>基于Python数据接口程序化使用数据</div>
            </div>
        </div>
        <div class="data_list">
                <div class="item_content" :key="item.id" v-for="item in resourceList">
                    <div class="item_title"><i :class="['iconfont',item.icon]">&nbsp;{{item.title}}</i> </div>
                    <div class="item_list">
                        <div class="item_list_arr"  :key="index" v-for="(val,index) in item.list">
                            <i :key="i" v-for="(name,i) in val" :style="'color:' + colorList[index]" class="iconfont icon-guanbi">&nbsp;<span style="color:#999">{{name}}</span> </i>
                        </div>
                    </div>
                    <div class="item_button flex-around">
                        <el-button type="primary" @click="intoItem(item.id)" >查看详情</el-button>
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                colorList: ['#27C805', '#1296DB', '#EECD67', '#FA9F5E', '#987EF7', '#FDD6F0', '#7EEFF5'],
                resourceList: [
                    {
                        id: 30,
                        icon: `iconfont icon-gupiao1`,
                        title: '股票数据',
                        list: [
                            ['中国股票', 'A股票', 'B股', '港股'],
                            ['美国股票', '纽约证券交易所', '纳斯达克市场']
                        ],
                        main: '包含中国市场及美国市场的股票数据',
                        isOpen: true
                    },
                    {
                        id: 38,
                        icon: `iconfont icon-caiwu `,
                        title: '财会数据',
                        list: [
                            ['年报季报', '业绩报表', '资产负债表', '利润表', '现金流量表'],
                            ['财务指标', '每股指标', '盈利能力', '成长能力', '营运能力', '偿债及资本结构', '现金流量']
                        ],
                        isOpen: true,
                        main: '更多领域数据即将开放...'
                    },
                    {
                        id: 31,
                        icon: `iconfont icon-caiyouduo_hemaixiangqing-fanganxiangqing `,
                        title: '期货数据',
                        list: [
                            ['商品期货', '上海期货交易所', '上海国际能源交易中心', '郑州商品交易所', '大连商品交易所'],
                            ['金融期货', '中国金融期货交易所'],
                            ['南华指数', '收益率指数', '价格指数', '波动率指数']
                        ],
                        main: '包含商品期货数据、金融期货数据与南华指数',
                        isOpen: true
                    },
                    {
                        id: 34,
                        icon: `iconfont icon-shishishuju`,
                        title: '宏观数据',
                        isOpen: true,
                        list: [
                            ['中国宏观杠杆率'],
                            ['国民经济运行状况', '经济状况', '物价水平'],
                            ['贸易状况'],
                            ['产业指标'],
                            ['中国电煤价格指数'],
                            ['其他指标']
                        ],
                        main:'包含中国、美国、欧元区、德国以及重要机构宏观数据'
                    },
                    {
                        id:32,
                        icon:`iconfont icon-shuju `,
                        title:'期权数据',
                        list:[
                            ['上海证劵交易所','行情数据','风险指标','标的物实时数据','合约分时数据'],
                            ['深圳证劵交易所','行情数据'],
                            ['中国金融期货交易所','行情数据','实时数据']

                        ],
                        main:'包含商品期权及金融期权的主要数据',
                        isOpen:true
                    },
                    {
                        id:33,
                        icon:`iconfont icon-DVLINK_waihuiziben`,
                        title:'外汇数据',
                        list:[
                            ['人民币牌价数据'],
                            ['人民币汇率中间价'],
                            ['货币对-投机情绪报告'],
                            ['外汇市场行情','人民币外汇即期报价','人民币外汇远掉报价','外币对即期报价']
                        ],
                        isOpen:true,
                        main:'包含主要国家外汇数据'
                    },
                    {
                        id:35,
                        icon:`iconfont icon-zu2327`,
                        title:'能源数据',
                        isOpen:true,
                        list:[
                            ['碳排放权','碳排放-国内','碳排放-国外'],
                            ['中国油价','历史调价','地区油价']
                        ],
                        main:'包含各大城市碳排放数据'
                    },
                    {
                        id:36,
                        icon:`iconfont icon-qitalei `,
                        title:'另类数据',
                        list:[
                            ['奥运奖牌','奥运历届','冬奥会历届'],
                            ['汽车销量','车企销量数据','品牌销量数据','车型销量数据'],
                            ['日出和日落','以天为单位','以月为单位'],
                            ['空气质量','全国空气质量','空气质量排名','监测点空气质量'],
                            ['新闻联播文字'],
                            ['生活成本'],
                            ['生活成本','电影票房','影院票房排行','视频放映']
                        ],
                        isOpen:true,
                        main:'包含不同领域、不同产业、不同行业的数据'
                    },


                ],
            }
        },
        created(){},
        methods:{
            intoItem(index){
                this.$store.commit('setPageId',{pageId:index})
                switch(index){
                    // 股票数据
                    case 30:
                        this.$router.push('/dataSourceStockData')
                    break;
                    // 期货数据
                    case 31:
                        this.$router.push('/dataSourceFuturesData')
                    break;
                    // 期权数据
                    case 32:
                        this.$router.push('/optionData')
                    break;
                    // 外汇数据
                    case 33:
                        this.$router.push('/foreignData')
                    break;
                    // 能源数据
                    case 35:
                        this.$router.push('/energyData')
                    break;
                    // 另类数据
                    case 36:
                        this.$router.push('/otherData')
                    break;
                    // 科创板IPO问询数据
                    case 1:
                        this.$router.push("/researchData?name=科创板IPO问询数据")
                    break;
                    // 创业板IPO问询数据
                    case 2:
                        this.$router.push("/researchData?name=创业板IPO问询数据")
                    break;
                    //宏观数据
                    case 34:
                        this.$router.push("/macroData")
                    break;
                    //财会数据
                    case 38:
                        this.$router.push("/accountingData")
                        // this.$message.warning('数据库更新维护中....')
                    break;
                }
            }
        },
    }
</script>
<style lang='scss' scoped>
.data_list{
    display: flex;
    flex-wrap: wrap;
    margin-right: 30px;
    width: 100vw;
    box-sizing: border-box;
    padding:0px 120px;

    .item_button{
        margin: 20px 0px;
    }
    .item_content{
        min-width:30%;
        background: white;
        margin: 30px calc(10% / 6);
        overflow: auto;
        &:hover{
            box-shadow: 0px 3px 12px #E6E6E6;
        }
        .item_title{
            padding: 26px 36px;
            i{
                font-size: 22px;
                font-weight: bold;
                color: #333333;
            }
        }
        .item_list{
            height: 250px;
            padding-left: 80px;
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            .item_list_arr{
                // min-width: 200px;
                i{
                    display: block;
                    line-height: 2;
                }
            }

        }
    }
}
.banner{
    height: 60vh;
    color: #ccc;
    font-size: 20px;
    background: url('../../assets/img/data_banner_one.png') 0 0/100% 100% no-repeat;
    >div{
        text-align: center;
    }
    .banner_title{
        font-size: 45px;
        font-weight: bold;
        color: white;
        margin-bottom: 25px;
        letter-spacing: 2px;
    }
}
.common_data_wrap{
    background: #FCFCFC;
}

</style>
